import { useEffect, useState } from 'react';
import {
  onAuthStateChanged,
  signInWithPopup,
  signOut,
  User,
} from 'firebase/auth';
import { auth, googleProvider } from '../firebase';

export type AuthState =
  | { status: 'loading' }
  | { status: 'signed-out' }
  | { status: 'access-denied'; email: string }
  | { status: 'authed'; user: User; token: string };

export function useAuth(): {
  state: AuthState;
  signIn: () => Promise<void>;
  signOutUser: () => Promise<void>;
} {
  const [state, setState] = useState<AuthState>({ status: 'loading' });

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setState({ status: 'signed-out' });
        return;
      }
      const token = await user.getIdToken();
      // Verify with worker that this email is allowlisted.
      const res = await fetch(
        `${import.meta.env.VITE_API_BASE}/api/auth/verify`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (res.status === 200) {
        setState({ status: 'authed', user, token });
      } else {
        setState({ status: 'access-denied', email: user.email || '' });
      }
    });
    return unsub;
  }, []);

  const signIn = async () => {
    await signInWithPopup(auth, googleProvider);
  };

  const signOutUser = async () => {
    await signOut(auth);
  };

  return { state, signIn, signOutUser };
}
